module.exports = __webpack_public_path__ + "img/paracoin.a490c0e2.png";